import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading, token, refreshToken, user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Auto-refresh token if close to expiry
    if (token && isAuthenticated) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiresIn = (payload.exp * 1000) - Date.now();
        
        // Refresh if less than 5 minutes remaining
        if (expiresIn < 5 * 60 * 1000 && expiresIn > 0) {
          refreshToken().catch(() => {
            // Refresh failed, will redirect to login
          });
        }
      } catch (error) {
        console.error('Token parsing error:', error);
      }
    }
  }, [token, isAuthenticated, refreshToken]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to homepage (not login page) — user can sign in from there
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireAuth;